import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
export function ConvenioSwitcher({ convenios, activeId, onChange }) {
    const [open, setOpen] = useState(false);
    const active = convenios.find((c) => c.id === activeId) ?? convenios[0];
    if (!active)
        return null;
    return (_jsxs("div", { style: { position: "relative" }, children: [_jsxs("button", { type: "button", onClick: () => setOpen((o) => !o), style: {
                    width: "100%",
                    background: "linear-gradient(135deg, rgba(201,169,97,.18), rgba(16,185,129,.12))",
                    border: "1px solid var(--border-strong)",
                    borderRadius: 10,
                    padding: "10px 12px",
                    textAlign: "left",
                    cursor: convenios.length > 1 ? "pointer" : "default",
                    color: "var(--text)",
                }, children: [_jsx("div", { style: { fontSize: 10, letterSpacing: "0.1em", color: "var(--accent)", fontWeight: 700, textTransform: "uppercase" }, children: "Conv\u00EAnio ativo" }), _jsx("div", { style: { marginTop: 4, fontSize: 13, fontWeight: 700 }, children: active.prefeitura }), _jsxs("div", { style: { fontSize: 11, color: "var(--text-muted)" }, children: [active.nome, convenios.length > 1 ? _jsx("span", { style: { float: "right", color: "var(--accent)" }, children: open ? "▴" : "▾" }) : null] })] }), open && convenios.length > 1 ? (_jsx("div", { style: {
                    position: "absolute",
                    top: "calc(100% + 4px)",
                    left: 0,
                    right: 0,
                    background: "var(--bg-elev)",
                    border: "1px solid var(--border-strong)",
                    borderRadius: 10,
                    boxShadow: "var(--shadow-lg)",
                    padding: 4,
                    zIndex: 50,
                    maxHeight: 280,
                    overflowY: "auto",
                }, children: convenios.map((c) => (_jsxs("button", { type: "button", onClick: () => {
                        onChange(c.id);
                        setOpen(false);
                    }, style: {
                        width: "100%",
                        textAlign: "left",
                        padding: "8px 10px",
                        borderRadius: 8,
                        background: c.id === activeId ? "var(--bg-elev-2)" : "transparent",
                        border: "none",
                        color: "var(--text)",
                        cursor: "pointer",
                        fontSize: 13,
                    }, children: [_jsx("div", { style: { fontWeight: 600 }, children: c.prefeitura }), _jsx("div", { style: { fontSize: 11, color: "var(--text-muted)" }, children: c.nome })] }, c.id))) })) : null] }));
}
//# sourceMappingURL=ConvenioSwitcher.js.map